import {
  GET_FUND_SPOTLIGHT_INIT,
  GET_FUND_SPOTLIGHT_SUCCESS,
  GET_FUND_SPOTLIGHT_FAILED,
  GET_LIST_OF_STRATEGIES_INIT,
  GET_LIST_OF_STRATEGIES_SUCCESS,
  GET_LIST_OF_STRATEGIES_FAILED,
  GET_RECENT_CHAT_INIT,
  GET_RECENT_CHAT_SUCCESS,
  GET_RECENT_CHAT_FAILED,
  GET_MEETINGS_INIT,
  GET_MEETINGS_SUCCESS,
  GET_MEETINGS_FAILED,
  SET_TOKEN,
  GET_RECENT_POST_INIT,
  GET_RECENT_POST_SUCCESS,
  GET_RECENT_POST_FAILED,
  GET_DASHBOARD_CONFIG_INIT,
  GET_DASHBOARD_CONFIG_SUCCESS,
  GET_DASHBOARD_CONFIG_FAILED,
  UPDATE_DASHBOARD_CONFIG_INIT,
  UPDATE_DASHBOARD_CONFIG_SUCCESS,
  UPDATE_DASHBOARD_CONFIG_FAILED,
} from "./constants";

const initialState = {
  loading: false,
  spotlightLoading: false,
  token: null,
  getFundDashboard: {},
  getStrategyList: [],
  getRecentChat: [],
  getMeeting: [],
  recentPosts: [],
  dashboardConfigResult: [],
  permissions: {},
  permissionsLoader: false,
};

export default function dashboard(state = initialState, action) {
  switch (action.type) {
    case GET_FUND_SPOTLIGHT_INIT:
      return { ...state, spotlightLoading: true };
    case GET_FUND_SPOTLIGHT_SUCCESS:
      return {
        ...state,
        spotlightLoading: false,
        getFundDashboard: action.payload,
      };
    case GET_FUND_SPOTLIGHT_FAILED:
      return { ...state, spotlightLoading: false };
    case GET_LIST_OF_STRATEGIES_INIT:
      return { ...state, loading: true };
    case GET_LIST_OF_STRATEGIES_SUCCESS:
      return { ...state, loading: false, getStrategyList: action.payload };
    case GET_LIST_OF_STRATEGIES_FAILED:
      return { ...state, loading: false };
    case GET_RECENT_CHAT_INIT:
      return { ...state, loading: true };
    case GET_RECENT_CHAT_SUCCESS:
      return { ...state, loading: false, getRecentChat: action.payload };
    case GET_RECENT_CHAT_FAILED:
      return { ...state, loading: false };
    case GET_MEETINGS_INIT:
      return { ...state, loading: true };
    case GET_MEETINGS_SUCCESS:
      return { ...state, loading: false, getMeeting: action.payload };
    case GET_MEETINGS_FAILED:
      return { ...state, loading: false };
    case GET_RECENT_POST_INIT:
      return { ...state, loading: true };
    case GET_RECENT_POST_SUCCESS:
      return { ...state, loading: false, recentPosts: action.payload };
    case GET_RECENT_POST_FAILED:
      return { ...state, loading: false };
    case GET_DASHBOARD_CONFIG_INIT:
      return { ...state, loading: true };
    case GET_DASHBOARD_CONFIG_SUCCESS:
      return {
        ...state,
        loading: false,
        dashboardConfigResult: action.payload,
      };
    case GET_DASHBOARD_CONFIG_FAILED:
      return { ...state, loading: false };
    case UPDATE_DASHBOARD_CONFIG_INIT:
      return { ...state, loading: true };
    case UPDATE_DASHBOARD_CONFIG_SUCCESS:
      return {
        ...state,
        loading: false,
        dashboardConfigResult: action.payload,
      };
    case UPDATE_DASHBOARD_CONFIG_FAILED:
      return { ...state, loading: false };
    case SET_TOKEN:
      let tokenGet = sessionStorage.getItem("token") ?? localStorage.getItem("token");
      return { ...state, token: tokenGet ? tokenGet : null };

    default:
      return state;
  }
}
